import BackendClient from '../backend-client';
import Notification, { modelFactory } from './model';

const formatNotifFeedback = (notif) => {
  const NOTIFICATION_SMS = 'sms';
  const NOTIFICATION_WHATSAPP = 'whatsapp';
  const NOTIFICATION_IS = true;
  const item = {};

  const hasNotificacion = !!notif.notificacion;
  const base = hasNotificacion ? notif.notificacion : notif;

  const typeNotification = notif.modo;
  if (typeNotification === NOTIFICATION_WHATSAPP || typeNotification === NOTIFICATION_SMS) {
    item.subject = `Notificación recibida por ${typeNotification === NOTIFICATION_WHATSAPP ? 'WhatsApp' : 'SMS'}`;
  } else {
    item.subject = base.asunto || null;
  }

  item.from = notif.de || null;
  item.type = notif.modo || null;
  item.origen = notif.modo || null;
  item.text = base.texto || null;

  if ((base.texto === null || base.texto === '') && base.html !== '') {
    item.text = base.html;
  }

  item.bussinessType = (base.tipoNegocio && base.tipoNegocio.id) ? base.tipoNegocio.id : null;

  const fecha = notif.fechas?.[hasNotificacion ? 'modificacion' : 'creacion'];
  item.creationDate = null;
  if (fecha) {
    const f = new Date(fecha);
    const dia = String(f.getDate()).padStart(2, '0');
    const mes = String(f.getMonth() + 1).padStart(2, '0');
    const anio = f.getFullYear();
    item.creationDate = `${dia}/${mes}/${anio}`;
  }

  item.id = hasNotificacion ? base.id : notif.id;
  item.isNotification = NOTIFICATION_IS;

  return item;
};

export default class NotificationsClient extends BackendClient {
  constructor(options = {}) {
    super(modelFactory, options);
  }

  list = async (pagination = false, start = 0, size = 10, filters = {}) => {
    const {
      type, bussinessType,
    } = filters;
    const response = await this.request('get')({
      pagination,
      start,
      size,
      type,
      bussiness_type: bussinessType,
    });

    return this.format(response);
  }

  get = (id) => this.req({}, { id });

  listFeedback = async (apiCges) => {
    const listNotif = new Map();
    const response = await this.request('get')(
      { apiCges },
      { path: 'gestnotif/feedback' },
    );

    console.log(response);
    const { collection_feedback: collectionFeedback } = response.data;
    collectionFeedback.feedback.forEach((element) => {
      // listNotif.push(formatNotifFeedback(element));
      const formatted = formatNotifFeedback(element);
      listNotif.set(formatted.id, formatted);
    });
    const uniqueListNotif = Array.from(listNotif.values());
    collectionFeedback.feedback = uniqueListNotif;
    return collectionFeedback;
  }

  notifById = async (data) => {
    const { id, apiCges } = data;
    try {
      const response = await this.request('get')(
        { apiCges },
        { path: `gestnotif/notificacion/${ id }` },
      );

      const { collection_notifications: collectionNotifications } = response.data;
      const notif = collectionNotifications.notifications[0];
      return formatNotifFeedback(notif);
    } catch (error) {
      return error.response;
    }
  }
}

export {
  Notification,
};
